import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from 'react';
import { FcCalendar, FcViewDetails } from "react-icons/fc";
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from "react-router-dom";
import Toast from '../../../helpers/Toast';
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceListDTO } from '../../../models/Assistance/AssistanceListDTO';
import { CreateAssistanceDTO } from '../../../models/Assistance/CreateAssistanceDTO';
import { GetAssistancesFromClientDTO } from '../../../models/Client/GetAssistancesFromClientDTO';
import { AssistanceService } from '../../../services/AssistanceService';
import { ClientService } from '../../../services/ClientService';
import TableComponent from "../../TableComponent";

function AssistancesFromClientB() {
    const { id } = useParams<{ id: string }>();
    const clientService = new ClientService();
    const assistanceService = new AssistanceService();
    const [assistances, setAssistances] = useState<AssistanceListDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);
    const navigate = useNavigate();
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.Document" />,
                accessor: "id",
                width: 20,
                Cell: (props: any) => {
                    return Utilities.FormattedAssistanceDocument(props.cell.row.original.docType, props.cell.row.original.serie, props.cell.row.original.number);
                },
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.Date" />,
                accessor: "date",
                width: 20,
                Cell: (props: any) => {
                    return props.cell.row.original.dateString;
                },
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.EquipmentCarPlate" />,
                accessor: "equipment.carPlate",
                width: 25,
            },
            {
                Header: <FormattedMessage id="Screens.AssistancesFromClient.Table.Column.Technician" />,
                accessor: "technician",
                width: 30,
            },
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    return (
                        <div style={{ display: "flex" }}>
                            <Tooltip title="Ver Detalhes" aria-label="Ver Detalhes" enterNextDelay={500} enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        createAssistance(
                                            "",
                                            props.cell.row.original.equipment.erpId,
                                            props.cell.row.original.equipment.serialNumber,
                                            props.cell.row.original.equipment.brand,
                                            props.cell.row.original.equipment.model,
                                            id!,
                                            props.cell.row.original.number,
                                            props.cell.row.original.docType,
                                            props.cell.row.original.serie
                                        );
                                    }}
                                >
                                    <FcViewDetails className="icons" />
                                </div>
                            </Tooltip>
                        </div>
                    );
                },
                width: 5
            },
        ],
        []
    );

    const GetAssistances = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: GetAssistancesFromClientDTO = {
            clientErpId: id!,
            currentPage: currentPage,
            pageSize: pageSize,
        }
        var response = await clientService.GetAssistancesFromClient(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setAssistances(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    const createAssistance = async (projectErpId: string, equipmentErpId: string, equipmentNumSerie: string, equipmentBrand: string, equipmentModel: string, clientErpId: string, numDoc: number, typeDoc: string, serie: string) => {
        var sendData: CreateAssistanceDTO = {
            equipmentErpId: equipmentErpId,
            equipmentNumSerie: equipmentNumSerie,
            equipmentBrand: equipmentBrand,
            equipmentModel: equipmentModel,
            projectErpId: null,
            clientErpId: clientErpId,
            numDoc: numDoc,
            typeDoc: typeDoc,
            serie: serie,
            id: 0,
            date: new Date(),
            description: null,
            notes: null,
            clientId: null,
            counter1: 0,
            counter2: 0,
            counter3: 0,
            assistanceType: null,
            stockEntryDocumentErpId: null,
            budgetSellingPrice: null,
            budgetCostPrice: null
        };

        setIsButtonCreateLoading(true);
        var response = await assistanceService.Create(sendData);
        setIsButtonCreateLoading(false);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        navigate(`/Backoffice/Assistance/${response.obj}`);
    };


    useEffect(() => {
        if (id !== '') {
            GetAssistances(currentPage ?? 1, pageSize ?? 5)
        }
    }, [id, currentPage, pageSize])

    return (
        <div>
            <TableComponent
                columns={columns}
                data={assistances}
                goToPage={goToPage}
                initialPage={currentPage}
                pageCount={pageCount}
                initialPageSize={pageSize}
                pageSizes={pageSizes}
                manualPagination={true}
                loading={isLoading}
                fetchData={GetAssistances}
                initialSortBy={[]}
                disableSortBy={true}
                dontOrderFirstCollumn={true}
            />
        </div>

    )
}

export default AssistancesFromClientB